<template>
    <ai-nav :showSearchIcon="true" :isAgent="true">
        <template>
            <div class="ai-chat-page">
                <div class="chat-container">
                    <div class="pl-1 font-18">{{ pageTitle }}</div>
                    <div class="messages">
                        <!-- 原有消息列表保持不变 -->
                        <div v-for="(mesg, index) in messages" :key="index"
                            :class="['message', mesg.sender == 'AI' ? 'message-left' : 'message-right']">
                            <div class="typewriter" v-if="mesg.message !== 'thinking' && !mesg.tips"
                                v-html="mesg.message"></div>
                            <div v-if="mesg.message === 'thinking'" class="thinking">
                                <i class="el-icon-loading mr-1"></i>
                                <span>Deepseek正在思考中，请您稍等……</span>
                            </div>
                            <div v-if="mesg.tips === true" :class="mesg.error ? 'redfont' : ''" class="thinking">
                                <span>{{ mesg.message }}</span>
                            </div>

                            <div class="mt-1" v-if="mesg.sender === 'AI'&& mesg.message === 'thinking'" >
                                本次研究任务预计需要花费2-3分钟。分析研究支持后台运行，您可以先去处理别的事情，3分钟后再来查看结果。</div>
                                <div class="mt-1" v-if="mesg.sender === 'AI' && mesg.message != 'thinking' && !mesg.tips">
                                    注：本回答由 AI 自动生成，内容仅供参考。</div>
                        </div>
                    </div>
                    <!-- 修改后的文本框区域，包含发送按钮 -->
                    <div class="textbox-container" v-show="type != 'history'">
                        <div class="textbox-wrapper">
                            <textarea class="simple-textbox" placeholder="输入问题，按Enter发送，Shift+Enter换行..."
                                v-model="question" @keydown.enter="handleSend" ref="textInput"></textarea>
                            <button class="send-button" @click="handleSend" :disabled="question == ''">
                                <i class="el-icon-s-promotion"></i>
                            </button>
                        </div>
                        <div class="textbox-hint">
                            <!-- <span>支持Markdown语法</span> -->
                            <span class="clear-chat" @click="clearMessages">清空对话</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ai-nav>
</template>

<script>
import { error } from 'jquery';
import aiNav from '../inc/aiNav.vue';
import { data } from 'jquery';
export default {
    components: { aiNav },
    data() {
        return {
            userdata: {},
            messages: [],
            question: "",
            userInput: { sender: "user", message: "dfasdfsdafdasf" },
            historyList: [
                { sender: "user", message: "比亚迪股份有限公司拿地数据和投资趋势分析" },
                { sender: "user", message: "宁德时代股份有限公司拿地数据和投资趋势分析" },
            ],
            type: 1,
            model: 1,
            id: 1,
            isUserScrolling: false,
            pageTitle: '',
        };
    },
    watch: {
        $route: function (newVal, oldVal) {
            console.log('watch');
            if (newVal.query.id !== oldVal.query.id) {
                this.id = newVal.query.id;
                // alert('历史记录');
                this.type = newVal.query.type;
                this.id = newVal.query.id;

                //清空当前数据，避免多条数据累加
                this.messages = [];
                this.getChat();
            }
        }
    },
    created() {
        this.userdata = this.getuseriformation();
        console.log(this.userdata);
        this.type = this.$route.query.type;
        this.id = this.$route.query.id;
        this.pageTitle = this.$route.query.title;
        //默认提示
        this.messages.push({ sender: "AI", message: '欢迎使用' + this.pageTitle + '，请输入您的问题', tips: true });
    },
    mounted() {
        if (this.type == 'history') { //历史记录才需要进入就获取数据，其他情况不需要
            this.getChat();
        }
    },
    methods: {
        handleSend(e) {
            // 如果是按钮点击事件，没有event参数
            if (e && e.shiftKey) {
                return; // Shift+Enter 换行
            }

            if (e) {
                e.preventDefault();
            }

            if (!this.question.trim()) return;

            // 发送消息逻辑
            console.log('发送消息:', this.question);
            // 这里可以添加你的消息发送逻辑
            // 模拟用户输入
            this.userInput = { sender: "user", message: this.question };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            // 清空输入框并保持焦点
            this.getChat();
            this.$nextTick(() => {
                this.$refs.textInput.focus();
            });
        },

        clearMessages() {
            this.messages = [];
        },

        // ... 其他方法保持不变 ...


        getChat() {
            let ajaxUrl = '', ajaxData = {};
            let that = this;
            if (this.type == 'history') {
                ajaxUrl = this.$api.common.tencent.detail();
                ajaxData = {
                    id: this.id,
                }
            } else {
                ajaxUrl = this.$api.common.tencent.assistantChat();
                ajaxData = {
                    id: this.id,
                    question: this.question,
                }
            }

            this.question = '';
            console.log(ajaxUrl, ajaxData);
            // return;

            $.ajax({
                url: ajaxUrl,
                type: this.type == 'history' ? "get" : "post",
                // dataType: "json",
                data: ajaxData,
                headers: { AuthToken: this.userdata.token},
                success: function (res) {
                    // 发送请求
                    console.log('res', res.data);
                    // return;
                    if (res.success) {
                       
                        let thinkingProcess = '', result = '';
                        if (that.type != 'history') { //如果不是历史记录要更新栏目历史记录数据
                            // 添加这行触发事件
                            that.bus.$emit('aiHistory-updated');
                            
                        }
                        that.pageTitle = res.data.title;
                        document.title = that.pageTitle;
                        // 如果 model == 2，拼接思考过程和结果
                        thinkingProcess = res.data.contentReason; // 假设后端返回的思考过程字段为 outputR1Chain
                        result = res.data.content; // 假设后端返回的结果字段为 outputR1

                        // 拼接思考过程和结果
                        console.log('res.success',thinkingProcess,result);
                        let fullMessage = '';
                            fullMessage = `<div class="thinking-process">\n${thinkingProcess}</div><div class="result">${result}</div>`;
                        
                        // 移除“思考中...”并展示完整消息
                        // if(that.type == 'history'){
                        //     逐字展示完整内容
                        // that.typeAnswer(fullMessage);
                        //     that.typeText({ sender: "AI", message: fullMessage }, 0);
                        // }else{
                        that.messages.pop();
                        that.messages.push({ sender: "AI", message: fullMessage });
                        // }


                    } else {
                        that.messages.push({ sender: "AI", message: '系统出错', error: true });
                    }
                },
                // error: function (error) {
                //     that.messages.push({ sender: "AI", message: '系统出错',tips:true });
                //     // 请求失败处理
                //     console.log(error);
                // },
            })

        },
        typeText(message, index) {
            if (index < message.message.length) {
                message.displayMessage += message.message.charAt(index);
                requestAnimationFrame(() => {
                    this.typeText(message, index + 1);
                });
            }
        },
        typeAnswer(answer, callback, isResult = false) {
            let i = 0;
            const timer = setInterval(() => {
                if (i < answer.length) {
                    this.displayedText.push(answer[i]);
                    i++;
                } else {
                    clearInterval(timer);
                }
            }, 100);
        },
        scrollToCenter() {
            const container = this.$el.querySelector(".messages");
            const chatContainer = this.$el.querySelector(".chat-container");
            console.log(container, chatContainer);
            if (container && chatContainer) {
                const containerHeight = container.scrollHeight;
                const chatHeight = chatContainer.clientHeight;

                // 计算滚动位置，让内容保持在正中间
                const scrollTop = (containerHeight - chatHeight) / 2;
                chatContainer.scrollTop = scrollTop > 0 ? scrollTop : 0;
            }
        },


    }
};
</script>

<style lang="scss">
/* 之前的样式保持不变，修改文本框区域样式 */

.typewriter {
    p span[style*="font-size: 10px"] {
        /* 匹配含特定样式的 span */
        display: none !important;
    }

    p:has(> :empty:last-child) {
        /* 匹配内容为空的<p> */
        display: inline;
    }

    p,
    h1,
    h2,
    h4,
    h3,
    h5,
    ul,
    ol,
    li,
    span {
        background: rgba(0, 0, 0, 0) !important;
    }

    table {
        width: 100%;
        border: 1px solid #E0E0E0 !important;
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0 auto;
    }

    hr {
        border-top: 1px solid #999 !important;
        margin-top: 25px;
    }

}

.ai-chat-page {
    width: 100%;
}

.chat-container {
    // width: 100%;
    // max-width: 1200px;
    // height: 90%;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 90vh;
    height: calc(100vh - 40px);
    overflow-y: auto;

}

.messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // justify-content: center; /* 垂直居中 */
    align-items: center;
    /* 水平居中 */
    // text-align: center; /* 文本居中 */
    width: 80%;
    margin: 0 auto;
    padding-top: 30px;
}

.message {
    // max-width: 100%;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 2;
    word-wrap: break-word;
}

.message-left {
    align-self: flex-start;
    // background-color: #e5e7ed;
    color: #333;
    border-top-left-radius: 0;
}

.message-right {
    align-self: flex-end;
    background-color: #37a3ff;
    color: #fff;
    border-top-right-radius: 0;
}

.thinking {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    font-style: italic;
    background-color: #e5e7ed;
    border-radius: 15px;
    border-top-left-radius: 0;
    padding-left: 20px;
    line-height: 40px;
    padding: 10px 15px;
    width: 360px;
}

.el-icon-loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.meun-box {
    position: fixed;
    bottom: 50%;
    left: 20px;
    padding: 3px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;

    .item:hover {
        background-color: #eee;
        border-radius: 10px;
    }

    span {
        padding: 7px;
        cursor: pointer;
        display: inline-block;
    }
}

.history-container {
    padding: 10px;
    width: 1200px;
    height: 90vh;

    .history-date {
        padding: 10px;
        border-radius: 10px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        color: #666;
        background-color: #fff;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover {
            box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;
        }
    }
}

.textbox-container {
    width: 80%;
    margin: 20px auto 0;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
}

.textbox-wrapper {
    position: relative;
    display: flex;
    align-items: flex-end;
}

.simple-textbox {
    width: 100%;
    min-height: 40px;
    max-height: 120px;
    padding: 10px 50px 10px 15px;
    /* 右侧留出按钮空间 */
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
        border-color: #37a3ff;
    }

    &::placeholder {
        color: #c0c4cc;
    }
}

.send-button {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 32px;
    height: 32px;
    border: none;
    background: #37a3ff;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
        background: #2d8de0;
    }

    &:disabled {
        background: #c0c4cc;
        cursor: not-allowed;
    }

    i {
        font-size: 16px;
    }
}

.textbox-hint {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    font-size: 12px;
    color: #999;

    .clear-chat {
        color: #37a3ff;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}

/* 保持其他原有样式不变 */
</style>